import React, {Component} from 'react';

class Header extends Component {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        return (

            <div className="template-header">

                <div className="template-header-top">

                    <div className="template-main template-clear-fix">

                        <div className="template-header-top-logo">
                            <a href="index.html">
                                <img src="media/image/logo_header.png" alt=""/>
                            </a>
                        </div>

                        <div className="template-header-top-menu template-clear-fix">

                            <nav className="template-component-menu-default">

                                <ul className="sf-menu template-clear-fix">

                                    <li className="sf-mega-enable-1">
                                        <a href="#"><span className="template-icon-menu template-icon-menu-home template-state-selected"></span>Anasayfa</a>

                                    </li>
                                    <li className="sf-mega-enable-1">
                                        <a href="#"><span className="template-icon-menu template-icon-menu-document"></span>Okulumuz</a>
                                    </li>
                                    <li className="sf-mega-enable-1">
                                        <a href="#"><span
                                            className="template-icon-menu template-icon-menu-printer"></span>Akivitelerimiz</a>
                                    </li>
                                    <li className="sf-mega-enable-1">
                                        <a href="#"><span className="template-icon-menu template-icon-menu-lab"></span>Derslerimiz</a>

                                    </li>
                                    <li className="sf-mega-enable-0">
                                        <a href="#"><span
                                            className="template-icon-menu template-icon-menu-envelope template-state-selected"></span>İletişim</a>

                                    </li>

                                </ul>

                            </nav>

                        </div>

                    </div>

                </div>


                <div className="template-header-bottom">

                    <div
                        className="template-header-bottom-background template-header-bottom-background-img-10 template-header-bottom-background-style-1">
                        <div className="template-main">
                            <h1>Turuncu Montessori Anaokulu</h1>
                            <h6>Sorularınız için Bizimle İletişime Geçin</h6>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Header;
